/**
 * The privacy and terms pages fetch their text from the API in the browser, so
 * their prerendered HTML used to be a bare "Yükleniyor..." with no heading —
 * the version search engines and Meta's app reviewers read first.
 *
 * scripts/prerender.mjs now fetches the Turkish text once at build time and
 * hands it over here: on the server through setPrerenderedLegal, in the browser
 * through window.__HUMO_LEGAL__ (written into that page's HTML), so the first
 * render already has the text. The page still fetches afterwards and replaces
 * it, which also covers English and any later edits.
 */
export type LegalDoc = "privacy-policy" | "terms-of-service";
type LegalDocs = Partial<Record<LegalDoc, string>>;

export const LEGAL_WINDOW_KEY = "__HUMO_LEGAL__";

let serverDocs: LegalDocs = {};

export function setPrerenderedLegal(docs: LegalDocs): void {
  serverDocs = docs;
}

export function prerenderedLegal(doc: LegalDoc, lang: string): string {
  if (lang !== "tr") return "";
  if (typeof window === "undefined") return serverDocs[doc] ?? "";
  const docs = (window as unknown as Record<string, LegalDocs | undefined>)[LEGAL_WINDOW_KEY];
  return docs?.[doc] ?? "";
}
